import { render, staticRenderFns } from "./AssetsNavbar.vue?vue&type=template&id=1b14da65&"
import script from "./AssetsNavbar.vue?vue&type=script&lang=js&"
export * from "./AssetsNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports